export const PEELING_HISTORY_REQUEST = "PEELING_HISTORY_REQUEST";
export const PEELING_HISTORY_SUCCESS = "PEELING_HISTORY_SUCCESS";
export const PEELING_HISTORY_FAILED = "PEELING_HISTORY_FAILED";
